import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Delete from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import HelpIcon from "@mui/icons-material/Help";
import Refresh from "@mui/icons-material/Refresh";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Hidden,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { withStyles } from "@mui/styles";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { pad, setColor2 } from "../../functions/default";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import MessageBox from "../shared/components/MessageBox";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(9),
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  paper: {
    margin: theme.spacing(2),
  },
  form: {
    margin: theme.spacing(1),
    flex: 1,
  },
});
function TimeCorrectionDetails(props) {
  const { t } = useTranslation();
  let { antragid } = useParams();
  const navigate = useNavigate();
  const [antraege, setAntraege] = useState(null);
  const { accessToken, client } = props;
  const [pause, setPause] = useState("");
  const [pausewert, setPauseWert] = useState("");
  const [regelung, setRegelung] = useState("");
  const [anzeigeKappung, setAnzeigeKappung] = useState("");
  const [kappung, setKappung] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [bemerkung, setBemerkung] = useState("");
  const [vonHRBearbeitet, setVonHRBearbeitet] = useState(false);
  const [zeitdaten, setZeitdaten] = useState([]);
  const [zeitdatenAntrag, setZeitdatenAntrag] = useState([{ von: "", bis: "", zeitart: "00" }]);
  const [zeitdatenOrig, setZeitdatenOrig] = useState([{ von: "", bis: "" }]);
  const { hideMessage, showErrorMessage } = useMessage();
  const [korrauswahl, setKorrauswahl] = useState("00");
  const [optionen, setOptionen] = useState("0");
  const [ansicht, setAnsicht] = useState(false);
  const [kenntnis, setKenntnis] = useState("0");
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [infoText, setInfoText] = useState(false);
  const [zeitarten, setZeitarten] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    if (antragid && antragid.substring(0, 1) === "M") {
      setAnsicht(true);
      const payload = {
        mandant: client,
        program: "PZKOA0",
        statement: "KORREKTUR_AUSWAHL",
        absence: antragid.substring(4),
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, antragCb);
    } else {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "KORREKTUR_AUSWAHL",
        absence: antragid.substring(3),
        antragVon: antragid.substring(0, 3),
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, antragCb);
    }
    // eslint-disable-next-line
  }, []);
  const antragCb = (response) => {
    if (response.status === 200) {
      if (response.data.vonHRBearbeitet === "1") {
        setVonHRBearbeitet(true);
      }
      setIsLoading(false);
      setAntraege(response.data.antraege);
      if (response.data.zeitarten) {
        setZeitarten(response.data.zeitarten);
      }
      if (response.data.antraege.zeitdaten) setZeitdaten(response.data.antraege.zeitdaten);
      if (response.data.antraege.zeitdatenorig) setZeitdatenOrig(response.data.antraege.zeitdatenorig);
      if (response.data.antraege.zeitdatenantrag) setZeitdatenAntrag(response.data.antraege.zeitdatenantrag);
      if (response.data.antraege.kenntnis) setKenntnis(response.data.antraege.kenntnis);
      setOptionen(response.data.antraege.optionen);
      setPause(response.data.antraege.pause);
      setPauseWert(response.data.antraege.pause_wert);
      setRegelung(response.data.antraege.regelung);
      setKappung(response.data.antraege.kappung);
      setAnzeigeKappung(response.data.antraege.anzeige_kappung);
      setKorrauswahl(response.data.antraege.korr);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const addRow = () => {
    var array = zeitdaten.slice();
    array.push({ von: "", bis: "", zeitart: "00" });
    setZeitdaten(array);
  };
  const insert = (row) => {
    var array = [...zeitdaten.slice(0, row), { von: "", bis: "", zeitart: "00" }, ...zeitdaten.slice(row)];
    setZeitdaten(array);
  };
  const delRow = (row) => {
    var array = [...zeitdaten];
    if (array.length < 2) return;
    array.splice(row, 1);
    setZeitdaten(array);
  };
  const zeitdatenaendern = (event, count, bonus) => {
    var array = zeitdaten.slice();
    if (event.target.id === "von") {
      array[count].von = event.target.value;
    }
    if (event.target.id === "bis") {
      array[count].bis = event.target.value;
    }
    if (bonus === "za") {
      array[count].zeitart = event.target.value;
    }
    setZeitdaten(array);
  };
  const aufgabeaktion = (aktion, art) => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "AKTION",
      absence: antragid.substring(3),
      antragVon: antragid.substring(0, 3),
      aktion: aktion,
      bemerkung: bemerkung,
      art: art,
      zeitdaten: zeitdaten,
      pause: pause,
      pausewert: pausewert,
      regelung: regelung,
      korropt: korrauswahl,
      kappung: kappung,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, aktionCB);
  };
  const messageBoxResult = (result) => {
    setMessageBoxOpen(false);
    if (result === "YES") {
      setIsLoading(true);
      const payload = {
        mandant: client,
        program: "PZKOA0",
        statement: "AKTION",
        absence: antragid && antragid.substring(0, 1) === "M" ? antragid.substring(4) : antragid.substring(3),
        aktion: antraege.status === "2" ? "ZURUECK" : "STORNO",
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, useraktionCB);
    }
  };
  const userAktion = (aktion) => {
    if (aktion === "STORNO") {
      setMessageBoxOpen(true);
      return;
    }
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "PZKOA0",
      statement: "AKTION",
      absence: antragid.substring(1),
      aktion: aktion,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, useraktionCB);
  };
  const useraktionCB = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.message === "OK") {
        hideMessage();
        navigate(-1);
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const aktionCB = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      hideMessage();
      navigate(-1);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const renderZeiten2 = () => {
    var pretime = "00:00";
    var posttime = "00:00";
    var tageswechsel = 0;
    var tmpdate = antraege.gestellt.substring(antraege.gestellt.indexOf(",") + 2);
    var nextday = new Date(Number(tmpdate.substring(6, 4)), Number(tmpdate.substring(3, 2) - 1), tmpdate.substring(0, 2));
    nextday.setDate(nextday.getDate() + 1);
    var nextdaytext = pad(nextday.getDate(), 2) + "." + pad(nextday.getMonth() + 1, 2) + "." + nextday.getFullYear();
    return zeitdaten.map((antwort, count) => {
      if (tageswechsel === 1) tageswechsel = 2;
      if (tageswechsel < 1) {
        if (
          ((!pretime || pretime === "00:00") && (!posttime || posttime === "00:00")) === false &&
          ((!antwort.von || antwort.von === "00:00") && (!antwort.bis || antwort.bis === "00:00")) === false
        ) {
          if (antwort.von.replace(":", "") < pretime.replace(":", "")) {
            tageswechsel = 1;
          }
        }
      }

      pretime = antwort.von;
      posttime = antwort.bis;
      if (!pretime) pretime = "00:00";
      if (!posttime) posttime = "00:00";
      return (
        <Fragment>
          {tageswechsel === 1 && (
            <Grid item xs={12}>
              <hr align="center" width="100%" height="2px" />
              {"Tageswechsel erkannt – Nachfolgende Zeiten gehören zum " + nextdaytext}
              <IconButton color="primary" size="small" onClick={() => setInfoText(true)}>
                <HelpIcon fontSize="small" />
              </IconButton>
              <hr align="center" width="100%" height="2px" />
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12} sm={zeitarten && zeitarten.length > 0 ? 4 : 6} lg={zeitarten && zeitarten.length > 0 ? 4 : 6}>
                <TextField
                  id="von"
                  label={t("Von")}
                  type="time"
                  fullWidth
                  disabled
                  value={antwort.von}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={zeitarten && zeitarten.length > 0 ? 4 : 6} lg={zeitarten && zeitarten.length > 0 ? 4 : 6}>
                <TextField
                  id="bis"
                  label={t("Bis")}
                  type="time"
                  fullWidth
                  disabled
                  value={antwort.bis}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
              </Grid>
              {zeitarten && zeitarten.length > 0 && (
                <Grid item xs={12} sm={4} lg={4}>
                  <TextField
                    id="za"
                    label={t("Zeitart")}
                    fullWidth
                    disabled
                    value={antwort.zeitart}
                    variant="outlined"
                    select
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 min
                    }}
                  >
                    {zeitarten.map((item, index) => (
                      <MenuItem key={index} value={item.key}>
                        {item.bez}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Fragment>
      );
    });
  };

  const renderZeiten = () => {
    var pretime = "00:00";
    var posttime = "00:00";
    var tageswechsel = 0;
    var tmpdate = antraege.gestellt.substring(antraege.gestellt.indexOf(",") + 2);
    var nextday = new Date(Number(tmpdate.substring(6, 4)), Number(tmpdate.substring(3, 2) - 1), tmpdate.substring(0, 2));
    nextday.setDate(nextday.getDate() + 1);
    var nextdaytext = pad(nextday.getDate(), 2) + "." + pad(nextday.getMonth() + 1, 2) + "." + nextday.getFullYear();
    return zeitdaten.map((antwort, count) => {
      if (tageswechsel === 1) tageswechsel = 2;
      if (tageswechsel < 1) {
        if (
          ((!pretime || pretime === "00:00") && (!posttime || posttime === "00:00")) === false &&
          ((!antwort.von || antwort.von === "00:00") && (!antwort.bis || antwort.bis === "00:00")) === false
        ) {
          if (antwort.von.replace(":", "") < pretime.replace(":", "")) {
            tageswechsel = 1;
          }
        }
      }

      pretime = antwort.von;
      posttime = antwort.bis;
      if (!pretime) pretime = "00:00";
      if (!posttime) posttime = "00:00";
      return (
        <>
          {tageswechsel === 1 && (
            <Grid item xs={12}>
              <hr align="center" width="100%" height="2px" />
              {"Tageswechsel erkannt – Nachfolgende Zeiten gehören zum " + nextdaytext}
              <IconButton color="primary" size="small" onClick={() => setInfoText(true)}>
                <HelpIcon fontSize="small" />
              </IconButton>
              <hr align="center" width="100%" height="2px" />
            </Grid>
          )}
          <Grid item xs={12} lg={2} alignItems="center">
            <Button id="addRow" fullWidth variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => insert(count)}>
              {t("Hinzufügen")}
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} lg={8}>
            <Grid container>
              <Grid item xs={12} sm={zeitarten && zeitarten.length > 0 ? 4 : 6} lg={zeitarten && zeitarten.length > 0 ? 4 : 6}>
                <TextField
                  id="von"
                  label={"Von"}
                  type="time"
                  fullWidth
                  value={antwort.von}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                  onChange={(event) => zeitdatenaendern(event, count)}
                />
              </Grid>
              <Grid item xs={12} sm={zeitarten && zeitarten.length > 0 ? 4 : 6} lg={zeitarten && zeitarten.length > 0 ? 4 : 6}>
                <TextField
                  id="bis"
                  label={"Bis"}
                  type="time"
                  fullWidth
                  value={antwort.bis}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                  onChange={(event) => zeitdatenaendern(event, count)}
                />
              </Grid>
              {zeitarten && zeitarten.length > 0 && (
                <Grid item xs={12} sm={4} lg={4}>
                  <TextField
                    id="za"
                    onChange={(event) => zeitdatenaendern(event, count, "za")}
                    label={t("Zeitart")}
                    fullWidth
                    value={antwort.zeitart}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    select
                  >
                    {zeitarten.map((item, index) => (
                      <MenuItem key={index} value={item.key}>
                        {item.bez}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
            </Grid>
          </Grid>
          {zeitdaten.length > 1 && (
            <Grid item xs={12} sm={12} lg={2}>
              <Button id="delRow" fullWidth variant="contained" color="primary" startIcon={<Delete />} onClick={() => delRow(count)}>
                {t("Entfernen")}
              </Button>
            </Grid>
          )}
        </>
      );
    });
  };
  const renderOrig = () => {
    return (
      <>
        <Grid item xs={12} md={6}>
          <Card>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" colSpan={3}>
                      {t("Originalzeiten")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {zeitdatenOrig.map((rows, tcount) => (
                    <TableRow>
                      <TableCell align="center">{rows.von}</TableCell>
                      <TableCell align="center">{"-"}</TableCell>
                      <TableCell align="center">{rows.bis}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box pb={1}>
            <Card>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" colSpan={zeitarten && zeitarten.length > 0 ? 4 : 3}>
                        {t("Antragszeiten")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {zeitdatenAntrag.map((rows, tcount) => (
                      <TableRow>
                        <TableCell align="center">{rows.von}</TableCell>
                        <TableCell align="center">{"-"}</TableCell>
                        <TableCell align="center">{rows.bis}</TableCell>
                        {zeitarten && zeitarten.length > 0 && (
                          <TableCell align="center">{zeitarten[zeitarten?.findIndex((e) => Number(e.key) === Number(rows.zeitart))]?.bez}</TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Box>
        </Grid>
      </>
    );
  };
  if (isLoading) {
    return <LoadingComponent />;
  }

  if (!antraege) {
    return (
      <Typography color="primary" variant="h5">
        {t("Antrag konnte nicht gefunden werden")}
      </Typography>
    );
  }
  return (
    <Box p={1}>
      <Hidden smDown>
        <Typography color="primary" variant="h5">
          {t("Details des Korrekturantrags")}
        </Typography>
      </Hidden>
      {ansicht === false && (
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} lg={8}>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
              {antraege.vg && antraege.vg !== "" && (
                <Grid item xs={12}>
                  <Typography align="center" fullWidth style={{ color: setColor2("255100100", 1) }}>
                    {"Stellvertretend für " + antraege.vg}
                  </Typography>
                </Grid>
              )}
              {vonHRBearbeitet && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backdropFilter: "blur(6px)",
                    backgroundColor: "rgba(0, 0, 0, 0.80)",
                    zIndex: 1000,
                    flex: 1,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignContent: "center",
                    padding: "20px",
                  }}
                >
                  <Typography
                    color={"error"}
                    style={{
                      fontWeight: "bold",
                      maxWidth: "600px",
                      margin: "auto",
                      marginBottom: "20px",
                    }}
                  >
                    {t(
                      "Antrag kann nicht angenommen werden, weil für den beantragten Zeitraum bereits eine Korrektur durch die HR-Abteilung vorgenommen wurde und daher keine weitere Änderung möglich ist.",
                    )}
                  </Typography>
                  <Button
                    startIcon={<DoneIcon />}
                    variant="contained"
                    color="primary"
                    onClick={() => aufgabeaktion("ABLEHNEN", antraege.art)}
                  >
                    {t("Zur Kenntnis genommen")}
                  </Button>
                </div>
              )}
              <Grid item xs={12}>
                {" "}
                <Card>
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" align="left">
                          {t("Antragsteller")}
                        </Typography>
                        <Typography align="left">{antraege.von}</Typography>
                      </Grid>
                      <Hidden smUp>
                        <Grid item xs={12}>
                          <Divider></Divider>
                        </Grid>
                      </Hidden>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" align="left">
                          {t("Antragszeitraum")}
                        </Typography>
                        <Typography align="left">{antraege.gestellt}</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              {renderOrig()}
              {renderZeiten()}
              <Fragment>
                <Grid item xs={12} sm={6}>
                  {zeitdaten && zeitdaten.length > 0 && (zeitdaten[zeitdaten.length - 1].von !== "" || zeitdaten[zeitdaten.length - 1].bis !== "") && (
                    <Button id="add" fullWidth variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => addRow()}>
                      {t("Neue Zeile Hinzufügen")}
                    </Button>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button fullWidth color="primary" startIcon={<Refresh />} onClick={() => setZeitdaten(JSON.parse(JSON.stringify(zeitdatenAntrag)))}>
                    {t("Zurücksetzen (Auf beantragte Zeiten)")}
                  </Button>
                </Grid>
                {(optionen === "0" || optionen === "1") && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      variant="outlined"
                      fullWidth
                      label={t("Erweiterter Arbeitszeitrahmen")}
                      margin="normal"
                      value={regelung}
                      helperText={antraege.regelung_korr !== "" && "beantragt: " + antraege.regelung_korr}
                      onChange={(event) => setRegelung(event.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem value="00">{t("Rahmen laut Plan")}</MenuItem>
                      <MenuItem value="10">{t("Vorarbeit")}</MenuItem>
                      <MenuItem value="01">{t("Nacharbeit")}</MenuItem>
                      <MenuItem value="11">{t("Vor- und Nacharbeit")}</MenuItem>
                    </TextField>
                  </Grid>
                )}
                {(optionen === "0" || optionen === "2") && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      variant="outlined"
                      label={t("Abweichende Pause")}
                      fullWidth
                      margin="normal"
                      value={pause}
                      helperText={antraege.pause_korr !== "" && "beantragt: " + antraege.pause_korr}
                      onChange={(event) => setPause(event.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem value="M">{t("Manuelle Vorgabe")}</MenuItem>
                      <MenuItem value="K">{t("Kein Pausenabzug")}</MenuItem>
                      <MenuItem value="P">{t("Pause laut Plan")}</MenuItem>
                    </TextField>
                  </Grid>
                )}
                {pause === "M" && (optionen === "0" || optionen === "2") && (
                  <Grid item xs={12}>
                    <TextField
                      type="time"
                      variant="outlined"
                      label={t("Abweichende Pause")}
                      fullWidth
                      margin="normal"
                      value={pausewert}
                      helperText={antraege.pause_wert !== "" && "beantragt: " + antraege.pause_wert}
                      onChange={(event) => setPauseWert(event.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    ></TextField>
                  </Grid>
                )}
                {anzeigeKappung === "J" && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={<Checkbox checked={kappung === "1"} onChange={(e) => (e.target.checked ? setKappung("1") : setKappung(""))} />}
                      label={"Kappung freigeben"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}
                {antraege.korr_auswahl.length > 1 && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      variant="outlined"
                      label={t("Vergütungsart")}
                      fullWidth
                      margin="normal"
                      value={korrauswahl}
                      helperText={antraege.korr !== "" && "beantragt: " + antraege.korr_auswahl.find((eintrag) => eintrag.key === antraege.korr).bez}
                      onChange={(event) => setKorrauswahl(event.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      {antraege.korr_auswahl.map((eintrag) => {
                        return <MenuItem value={eintrag.key}>{eintrag.bez}</MenuItem>;
                      })}
                    </TextField>
                  </Grid>
                )}

                {antraege.hinwan !== "" && (
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label={t("Bemerkung (Antragsteller)")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      disabled
                      multiline
                      value={antraege.hinwan}
                    ></TextField>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label={t("eigene Bemerkung")}
                    id="eigeneBemerkung"
                    value={bemerkung}
                    multiline
                    onChange={(event) => setBemerkung(event.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button fullWidth variant="contained" color="primary" startIcon={<DoneIcon />} onClick={() => aufgabeaktion("GENEHMIGEN", antraege.art)}>
                    {t("Antrag genehmigen")}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button fullWidth variant="outlined" color="primary" startIcon={<CloseIcon />} onClick={() => aufgabeaktion("ABLEHNEN", antraege.art)}>
                    {t("Antrag ablehnen")}
                  </Button>
                </Grid>
              </Fragment>
            </Grid>
          </Grid>
        </Grid>
      )}
      {ansicht === true && (
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} lg={8}>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("Antragsstatus")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={
                    antraege.bemkz === "T"
                      ? "Antrag automatisch abgelehnt"
                      : antraege.status === "2"
                        ? "Antrag abgelehnt"
                        : antraege.status === "1"
                          ? "Antrag genehmigt"
                          : ""
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("Antragszeitraum")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={antraege.gestellt}
                ></TextField>
              </Grid>
              {renderOrig()}
              {antraege.status === "1" && (
                <Fragment>
                  <Grid item lg={12} md={12} sm={12}>
                    <Typography color="primary" fullWidth variant="h5">
                      {t("Genehmigte Zeiten")}
                    </Typography>
                  </Grid>
                  {renderZeiten2()}
                </Fragment>
              )}
              <Fragment>
                {(optionen === "0" || optionen === "1") && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      variant="outlined"
                      fullWidth
                      label={t("Erweiterter Arbeitszeitrahmen")}
                      margin="normal"
                      value={antraege.status === "2" ? antraege.regelung : antraege.vgregelung}
                      disabled
                      helperText={antraege.status !== "2" && antraege.regelung_korr !== "" && "beantragt: " + antraege.regelung_korr}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem value="00">{t("Rahmen laut Plan")}</MenuItem>
                      <MenuItem value="10">{t("Vorarbeit")}</MenuItem>
                      <MenuItem value="01">{t("Nacharbeit")}</MenuItem>
                      <MenuItem value="11">{t("Vor- und Nacharbeit")}</MenuItem>
                    </TextField>
                  </Grid>
                )}
                {(optionen === "0" || optionen === "2") && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      variant="outlined"
                      label={t("Abweichende Pause")}
                      fullWidth
                      margin="normal"
                      disabled
                      value={antraege.status === "2" ? antraege.pause : antraege.vgpause}
                      helperText={antraege.status !== "2" && antraege.pause_korr !== "" && "beantragt: " + antraege.pause_korr}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem value="M">{t("Manuelle Vorgabe")}</MenuItem>
                      <MenuItem value="K">{t("Kein Pausenabzug")}</MenuItem>
                      <MenuItem value="P">{t("Pause laut Plan")}</MenuItem>
                    </TextField>
                  </Grid>
                )}
                {(pause === "M" || antraege.vgpause === "M") && (optionen === "0" || optionen === "2") && (
                  <Grid item xs={12}>
                    <TextField
                      type="time"
                      variant="outlined"
                      label={t("Abweichende Pause")}
                      fullWidth
                      disabled
                      margin="normal"
                      value={antraege.status === "2" ? antraege.pause_wert : antraege.vgpause_wert}
                      helperText={antraege.status !== "2" && antraege.pause_wert !== "" && "beantragt: " + antraege.pause_wert}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}
                {anzeigeKappung === "J" && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={<Checkbox disabled checked={antraege.status === "2" ? antraege.kappung === "1" : antraege.vgkappung === "1"} />}
                      label={"Kappung freigeben"}
                      helperText={
                        antraege.status !== "2" ? (antraege.kappung === "1" ? "beantragt: Kappung freigeben" : "beantragt: Kappung nicht freigeben") : ""
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}
                {antraege.korr_auswahl.length > 1 && (
                  <Grid item xs={12}>
                    <TextField
                      disabled
                      select
                      variant="outlined"
                      label={t("Vergütungsart")}
                      fullWidth
                      margin="normal"
                      value={antraege.status === "2" ? antraege.korr : antraege.vgkorr}
                      helperText={
                        antraege.status !== "2" &&
                        antraege.korr !== "" &&
                        "beantragt: " + antraege.korr_auswahl.find((eintrag) => eintrag.key === antraege.korr).bez
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      {antraege.korr_auswahl.map((eintrag) => {
                        return <MenuItem value={eintrag.key}>{eintrag.bez}</MenuItem>;
                      })}
                    </TextField>
                  </Grid>
                )}

                {antraege.hinwan !== "" && (
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label={t("eigene Bemerkung")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      disabled
                      multiline
                      defaultValue={antraege.hinwan}
                    />
                  </Grid>
                )}
                {antraege.hinwvg !== "" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label={t("Bemerkung (Vorgesetzter)")}
                      defaultValue={antraege.hinwvg}
                      disabled
                    />
                  </Grid>
                )}
                {kenntnis !== "1" && (
                  <Grid item xs={12} sm={6}>
                    <Button fullWidth variant="contained" color="primary" startIcon={<DoneIcon />} onClick={() => userAktion("KENNTNIS")}>
                      {t("Zur Kenntnis nehmen")}
                    </Button>
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <Button fullWidth variant="contained" color="primary" startIcon={<CloseIcon />} onClick={() => userAktion("STORNO")}>
                    {antraege.status === "2" ? t("Antrag löschen") : t("Stornieren")}
                  </Button>
                </Grid>
              </Fragment>
            </Grid>
          </Grid>
        </Grid>
      )}
      <MessageBox
        open={messageBoxOpen}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={t("Wollen Sie den Antrag wirklich löschen?")}
        title={t("Hinweis")}
        onClose={() => setMessageBoxOpen(false)}
      />
      <ResponsiveDialog title={t("Hinweis Tageswechsel")} open={infoText} setOpen={(o) => setInfoText(false)}>
        <Box p={2}>
          <Typography>
            {t(
              "Das System erwartet die Eingabe der Arbeitszeiten in chronologischer Reihenfolge – d.h. in exakt derselben Reihenfolge wie Sie diese auch gearbeitet haben.",
            )}
            <br />
            {t(
              "Dadurch werden Arbeitszeiten mit einer niedrigeren Uhrzeit dem Folgetag zugeordnet, falls sie nach Arbeitszeiten mit einer höheren Uhrzeit erfasst werden.",
            )}
            <br />
            <br />
            {t("Beispiel:")}
            <br />
            {t("Korrekturen für den 01.06.")}
            <br />
            {t("Zeile 1   12:00 – 20:00 Uhr")}
            <br />
            {t("Zeile 2   3:00 – 5:00 Uhr (ein Tageswechsel wird erkannt und die Zeiten werden dem Folgetag – in diesem Fall dem 02.06. zugeordnet)")}
            <br />
            <br />
            {t("Wenn die Zeiten in der umgekehrten Reihenfolge erfasst werden, werden beide Zeiten dem ausgewählten Tag (01.06.) zugeordnet:")}
            <br />
            {t("Zeile 1   3:00 – 5:00 Uhr")}
            <br />
            {t("Zeile 2   12:00 – 20:00 Uhr")}
            <br />
            <br />
            {t("Bitte erfassen Sie Ihre Zeiten daher immer in der tatsächlichen Reihenfolge, damit das System die richtige Zuordnung vornehmen kann.")}
          </Typography>
        </Box>
      </ResponsiveDialog>
    </Box>
  );
}
export default withStyles(styles)(TimeCorrectionDetails);
